import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import L from 'leaflet';

// Icono personalizado para Leaflet vía CDN sin conflictos de rutas locales
const pinIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export default function RegistroUbicacionPage() {
  const { paqueteId, tipo } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    loc_id: null,
    loc_nombre: '',
    loc_direccion: '',
    loc_distrito: '',
    loc_referencia: '',
    ven_fechaevento: ''
  });

  const [sugerencias, setSugerencias] = useState([]);
  
  const mapContainerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  // Autocompletado backend para locales
  useEffect(() => {
    if (tipo === 'local' && formData.loc_nombre.length >= 2 && !formData.loc_id) {
      axios.get(`https://backend-bambos.onrender.com/api/locales/buscar/?q=${formData.loc_nombre}`)
        .then(res => setSugerencias(res.data))
        .catch(err => console.error(err));
    } else {
      setSugerencias([]);
    }
  }, [formData.loc_nombre, tipo, formData.loc_id]);

  // Inicialización del Mapa Interactivo Leaflet / OpenStreetMap
  useEffect(() => {
    if (!document.getElementById('leaflet-css')) {
      const link = document.createElement('link');
      link.id = 'leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }

    if (mapContainerRef.current && !mapInstanceRef.current) {
      // Coordenadas iniciales: Huancayo (-12.0651, -75.2049)
      const map = L.map(mapContainerRef.current).setView([-12.0651, -75.2049], 15);
      mapInstanceRef.current = map;

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(map);

      // Evento de clic en el mapa para marcar punto y obtener dirección
      map.on('click', async (e) => {
        const { lat, lng } = e.latlng;

        if (markerRef.current) {
          markerRef.current.setLatLng([lat, lng]);
        } else {
          markerRef.current = L.marker([lat, lng], { icon: pinIcon }).addTo(map);
        }

        try {
          const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`);
          const data = await res.json();

          if (data && data.address) {
            const via = data.address.road || data.address.pedestrian || data.address.suburb || '';
            const numero = data.address.house_number ? ` ${data.address.house_number}` : '';
            const direccionGenerada = `${via}${numero}`.trim() || data.display_name.split(',')[0];
            const distritoGenerado = data.address.suburb || data.address.city_district || data.address.town || data.address.city || 'Huancayo';

            setFormData(prev => ({
              ...prev,
              loc_direccion: direccionGenerada || prev.loc_direccion,
              loc_distrito: distritoGenerado || prev.loc_distrito
            }));
          }
        } catch (error) {
          console.error("Error obteniendo dirección del punto:", error);
        }
      });
    }

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  const seleccionarSugerencia = (local) => {
    setFormData({
      ...formData,
      loc_id: local.loc_id,
      loc_nombre: local.loc_nombre,
      loc_direccion: local.loc_direccion,
      loc_distrito: local.loc_distrito
    });
    setSugerencias([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // 1. Guardar la reserva temporalmente en el navegador
    const reservaData = {
      paq_id: paqueteId,
      tipo_evento: tipo,
      ...formData
    };
    sessionStorage.setItem('reserva_temp', JSON.stringify(reservaData));

    // 2. Verificar autenticación
    const token = localStorage.getItem('token');
    const rutaPago = `/pago/${paqueteId}/${tipo}`;

    if (!token) {
      alert("Para continuar con tu reserva, inicia sesión o regístrate.");
      // Redirige al login con la instrucción de regresar al pago tras autenticarse
      navigate(`/login?redirect=${encodeURIComponent(rutaPago)}`);
    } else {
      // Si ya está logueado, avanza directamente al pago
      navigate(rutaPago);
    }
  };

  return (
    <div style={{ maxWidth: '1400px', margin: '30px auto', color: '#fff', padding: '0 25px', fontFamily: 'Arial, sans-serif' }}>
      
      <h2 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '32px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '2px' }}>
        Ubicación del Evento (<span style={{ color: '#FFD700' }}>{tipo.toUpperCase()}</span>)
      </h2>
      
      <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
        
        {/* COLUMNA IZQUIERDA: FORMULARIO */}
        <form onSubmit={handleSubmit} style={{ flex: '1 1 480px', backgroundColor: '#111', padding: '35px', borderRadius: '15px', border: '1px solid #333', boxShadow: '0 8px 25px rgba(0,0,0,0.5)' }}>
          
          {tipo === 'local' && (
            <div style={{ position: 'relative', marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '15px' }}>Nombre del Local / Salón:</label>
              <input 
                type="text"
                required
                value={formData.loc_nombre}
                onChange={(e) => setFormData({ ...formData, loc_nombre: e.target.value, loc_id: null })}
                placeholder="Ej: Local Las Flores"
                style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #444', backgroundColor: '#222', color: '#fff', fontSize: '15px', outline: 'none' }}
              />
              
              {sugerencias.length > 0 && (
                <ul style={{ position: 'absolute', background: '#222', width: '100%', listStyle: 'none', padding: 0, margin: 0, border: '1px solid #444', zIndex: 100, borderRadius: '8px' }}>
                  {sugerencias.map((item) => (
                    <li 
                      key={item.loc_id} 
                      onClick={() => seleccionarSugerencia(item)}
                      style={{ padding: '12px', cursor: 'pointer', borderBottom: '1px solid #333', fontSize: '14px' }}
                    >
                      <strong>{item.loc_nombre}</strong> — {item.loc_distrito}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '15px' }}>Distrito:</label>
            <input 
              type="text"
              required
              value={formData.loc_distrito}
              onChange={(e) => setFormData({ ...formData, loc_distrito: e.target.value })}
              placeholder="Ej: El Tambo, Chilca, Huancayo"
              style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #444', backgroundColor: '#222', color: '#fff', fontSize: '15px', outline: 'none' }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '15px' }}>Dirección Exacta:</label>
            <input 
              type="text"
              required
              value={formData.loc_direccion}
              onChange={(e) => setFormData({ ...formData, loc_direccion: e.target.value })}
              placeholder="Ej: Av. Las Flores 123"
              style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #444', backgroundColor: '#222', color: '#fff', fontSize: '15px', outline: 'none' }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '15px' }}>Referencia de Ubicación:</label>
            <input 
              type="text"
              value={formData.loc_referencia}
              onChange={(e) => setFormData({ ...formData, loc_referencia: e.target.value })}
              placeholder="Ej: Frente al parque San Carlos, puerta negra"
              style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #444', backgroundColor: '#222', color: '#fff', fontSize: '15px', outline: 'none' }}
            />
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '15px' }}>Fecha del Evento:</label>
            <input 
              type="date"
              required
              value={formData.ven_fechaevento}
              onChange={(e) => setFormData({ ...formData, ven_fechaevento: e.target.value })}
              style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #444', backgroundColor: '#222', color: '#fff', fontSize: '15px', outline: 'none' }}
            />
          </div>

          <button type="submit" style={{ width: '100%', background: '#FFD700', color: '#000', padding: '16px', fontWeight: '900', fontSize: '16px', border: 'none', borderRadius: '8px', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '1px' }}>
            CONTINUAR AL PAGO →
          </button>
        </form>

        {/* COLUMNA DERECHA: MAPA INTERACTIVO CON CLIC */}
        <div style={{ flex: '1.4 1 600px', backgroundColor: '#111', padding: '20px', borderRadius: '15px', border: '1px solid #333', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 25px rgba(0,0,0,0.5)' }}>
          <h4 style={{ margin: '0 0 15px 0', color: '#FFD700', textAlign: 'center', fontWeight: 'bold', fontSize: '18px' }}>
             Haz clic en el mapa para fijar tu ubicación
          </h4>
          
          <div 
            ref={mapContainerRef} 
            style={{ width: '100%', height: '550px', borderRadius: '10px', border: '1px solid #444', zIndex: 1 }}
          />
          
          <p style={{ color: '#aaa', fontSize: '13px', textAlign: 'center', marginTop: '12px', marginBottom: 0 }}>
            Puedes hacer clic o arrastrar en el mapa. Los campos de dirección y distrito se actualizarán automáticamente.
          </p>
        </div>

      </div>
    </div>
  );
}